import { IEcommerceProduct } from '../../analytics/types/events/legacy'

type ProductBaseProperties = {
  product_id: string
  product_variant_id?: string | null | undefined
  brand: string
  name: string
  colour?: string
  variant?: string
  price?: number | null | undefined
  retailer_id?: string | null | undefined
  retailer_name?: string
  promotions?: {
    promotion_id: string
    promotion_name: string
    promotion_type: 'auto' | 'coupon'
  }[]
}

export default function makeProductBaseProperties(
  product: IEcommerceProduct
): ProductBaseProperties {
  const productProperties = {
    product_id: product.dimension136 || product.dimension137 || '',
    product_variant_id: product.uniqueId || '',
    brand: product.brand || '',
    name: product.name,
    variant: product.variant,
    retailer_id: product.dimension128 || '',
    retailer_name: product.dimension127 || '',
    price: product.price,
    promotions: [
      ...(product.dimension131 && product.dimension132
        ? ([
            {
              promotion_type: 'auto',
              promotion_id: product.dimension131,
              promotion_name: product.dimension132,
            },
          ] as const)
        : []),
      ...(product.dimension133 && product.dimension134
        ? ([
            {
              promotion_type: 'coupon',
              promotion_id: product.dimension133,
              promotion_name: product.dimension134,
            },
          ] as const)
        : []),
    ],
  }
  return productProperties
}
